import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { SimplePdfPreviewPopup } from "@/Common/Components/Pdf/SimplePdfPreviewPopup";
import { QuestionnaireStatusInfo } from "@/Common/Models/Questionnaires/QuestionnaireStatusInfo";

interface IQuestionnairePdfPopupProps {
    questionnaire: QuestionnaireStatusInfo;

    onClose: () => void;
    onCorrect: () => void;
}

class QuestionnairePdfPopup extends BaseReactComponent<IQuestionnairePdfPopupProps> {
    public render(): JSX.Element {
        if (!this.props.questionnaire)
            return null;

        return (
            <SimplePdfPreviewPopup
                title={cacheStore.GetString("QuestionnaireDetailsLabel")}
                sourceUrl={this.props.questionnaire.PdfPreviewUrl}
                footer={this.renderFooter()}
                onClose={() => this.close()}
            />
        );
    }

    private renderFooter(): JSX.Element {
        if (!this.props.questionnaire.isSubmittable())
            return null;

        return (
            <div className="p-footer text-right">
                <button className="btn btn-default push-right-5" onClick={() => this.close()}>{cacheStore.GetString("CancelLabel")}</button>
                <button className="btn btn-primary" onClick={() => this.correct()}>{cacheStore.GetString("CorrectLabel")}</button>
            </div>
        );
    }

    private close(): void {
        this.props.onClose && this.props.onClose();
    }

    private correct(): void {
        this.props.onCorrect && this.props.onCorrect();
    }
}

export { QuestionnairePdfPopup };
